<p>bank-card-transactions works!</p>
<table>
	<tr>
		<th>a</th>
		<th>b</th>
	</tr>
	<tr *ngFor="let item of data">
		<td>{{ item.name }}</td>
		<td>{{ item.value }} {{ item.currency }}</td>
		<td>
			<div class="form-check form-switch">
				<input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
				<label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label>
			</div>
		</td>
		<td>
			<button type="button" class="btn btn-primary">Rozdziel</button>
		</td>
	</tr>
</table>
